import ConnectBanner from "../renderers/connect-banner";
import DisconnectBanner from "../renderers/disconnect-banner";
import QueuedBanner from "../renderers/queued-banner";
import InputBoxLiveChatMutator from '../renderers/inputbox-mutator';
import HeaderBannerLiveChatRenderer from '../renderers/header-banner-renderer';
import WindowLiveChatMutator from '../renderers/window-mutator';
import ResponseRenderer from '../renderers/response-renderer';
import InputRenderer from '../renderers/input-renderer';
import EndChatLinkRenderer from '../renderers/endchat-link-renderer';
import TypingNotificationRenderer from '../renderers/typing-notification-renderer';
import InputBoxButtonLiveChatMutator from "../renderers/inputbox-button-mutator";
import EndChatWarningOverlay from '../../../livechat-endchat-warning-overlay/src/end-chat-warning-overlay';
import {DefaultSettings} from "../../../../settings/settings-util";
import {Store} from "redux";
import {AlmeState} from "../../../../wireup/AlmeState";
import LiveChatState from "../livechat-state";
import ErrorMutator from "../renderers/error-mutator";

export default class UI
{

    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    _stateManager: LiveChatState;
    _headerBannerRenderer: HeaderBannerLiveChatRenderer;
    _endChatWarningOverlay: EndChatWarningOverlay;
    _endChatRenderer: EndChatLinkRenderer;
    _connectBanner: ConnectBanner;
    _disconnectBanner: DisconnectBanner;
    _queuedBanner: QueuedBanner;
    _errorMutator: ErrorMutator;
    _inputBoxMutator: InputBoxLiveChatMutator;
    _inputBoxButtonMutator: InputBoxButtonLiveChatMutator;
    _windowMutator: WindowLiveChatMutator;
    _responseRenderer: ResponseRenderer;
    _inputRenderer: InputRenderer;
    _typingNotificationRenderer: TypingNotificationRenderer;


    //#region Public Interface

    constructor(settings: DefaultSettings, stateManager: LiveChatState)
    {
        this._settings = settings;
        this._stateManager = stateManager;

        this._headerBannerRenderer = new HeaderBannerLiveChatRenderer(settings, this._stateManager);
        this._endChatWarningOverlay = new EndChatWarningOverlay(settings, this._stateManager);
        this._endChatRenderer = new EndChatLinkRenderer(settings, this._stateManager, this._endChatWarningOverlay);
        this._connectBanner = new ConnectBanner(settings, this._stateManager);
        this._disconnectBanner = new DisconnectBanner(settings);
        this._queuedBanner = new QueuedBanner(settings, this._stateManager);
        this._errorMutator = new ErrorMutator(settings, this._stateManager);
        this._inputBoxMutator = new InputBoxLiveChatMutator(settings, this._stateManager);
        this._inputBoxButtonMutator = new InputBoxButtonLiveChatMutator(settings, this._stateManager);
        this._windowMutator = new WindowLiveChatMutator(settings);
        this._responseRenderer = new ResponseRenderer(settings, this._stateManager);
        this._inputRenderer = new InputRenderer(settings);
        this._typingNotificationRenderer = new TypingNotificationRenderer(settings, this._stateManager);
    }

    initialize(store: Store<AlmeState>): void
    {
        this._store = store;

        this._connectBanner.initialize(store);
        this._disconnectBanner.initialize(store);
        this._queuedBanner.initialize(store);
        this._inputBoxMutator.initialize(store);
        this._errorMutator.initialize(store);
        this._inputBoxButtonMutator.initialize(store);
        this._headerBannerRenderer.initialize(store);
        this._windowMutator.initialize(store);
        this._responseRenderer.initialize(store);
        this._inputRenderer.initialize(store);
        this._endChatWarningOverlay.initialize(store);
        this._endChatRenderer.initialize(store);
        this._typingNotificationRenderer.initialize(store);
    }

    get inputBox(): InputBoxLiveChatMutator { return this._inputBoxMutator; }
    get inputBoxButton(): InputBoxButtonLiveChatMutator { return this._inputBoxButtonMutator; }
    get header(): HeaderBannerLiveChatRenderer { return this._headerBannerRenderer; }
    get window(): WindowLiveChatMutator { return this._windowMutator; }
    get response(): ResponseRenderer { return this._responseRenderer; }
    get input(): InputRenderer { return this._inputRenderer; }
    get connectBanner(): ConnectBanner { return this._connectBanner; }
    get disconnectBanner(): DisconnectBanner { return this._disconnectBanner; }
    get queuedBanner(): QueuedBanner { return this._queuedBanner; }
    get endChatLink(): EndChatLinkRenderer { return this._endChatRenderer; }
    get typingNotification(): TypingNotificationRenderer { return this._typingNotificationRenderer; }
    get endChatWarningOverlay(): EndChatWarningOverlay { return this._endChatWarningOverlay; }
    get errorMutator(): ErrorMutator { return this._errorMutator; }

    //#endregion
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/livechat-foundation/src/handlers/ui.ts